<script>
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import validation from '../../../helpers/validation';
import axios from 'axios';
import {convertToSQLDate, slugify} from "@/state/helpers";
import router from "@/router";
import ErrorAlert from "@/components/errorAlert";
import AccountForm from "@/components/accountForm";
import NetworksForm from "@/components/networksForm";
import PhoneSelect from "../../../components/phoneSelect";
import DateInput from "@/components/dateInput";

export default {
  page: {
    title: "Profile",
  },
  components: {
    DateInput,
    PhoneSelect,
    NetworksForm,
    AccountForm,
    ErrorAlert,
    Layout,
    Multiselect,
  },
  data() {
    return {
      title: "Initial profile setup",
      showModal: false,
      registeredAs: 'company',
      items: [
        {
          text: "Initial profile setup",
          active: true
        },
      ],
      categories: {
        selected: [],
        error: false,
      },
      companyForms: {
        personalInfo: {
          name: 'Company Info',
          fields: {
            company_name: {
              name: 'Full company name',
              value: '',
              required: true,
              error: false,
            },
            vat_number: {
              name: 'VAT number',
              value: '',
              required: true,
              error: false
            },
            company_number: {
              name: 'Registration number',
              value: '',
              required: true,
              error: false
            },
            taxpayer: {
              name: 'VAT (PDV)',
              value: true,
              type: 'radio',
              required: true,
              error: false
            },
            name: {
              name: 'Full name',
              value: '',
              required: true,
              error: false,
            },
            date_of_birth: {
              name: 'Date of Birth',
              value: '',
              type: 'date',
              required: true,
              error: false,
            },
            gender: {
              name: 'Gender',
              value: '',
              options: ['male', 'female'],
              type: 'select',
              error: false,
            },
            country: {
              name: 'Country',
              value: '',
              options: ['Serbia', 'Bosnia and Herzegovina', 'Slovenia', 'Croatia', 'Montenegro', 'Macedonia'],
              type: 'select',
              error: false,
            },
            city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            street_address: {
              name: 'Street address',
              value: '',
              required: true,
              error: false
            },
            phone_number: {
              name: 'Phone',
              value: '',
              type: 'phone',
              required: true,
              error: false,
            },
            main_social_network: {
              name: 'Profile picture & username from',
              value: '',
              options: [],
              type: 'select',
              error: false,
              hidden: true
            }
          }
        },
        bankingInfo: {
          name: 'Banking info',
          fields: {
            bank: {
              name: 'Bank',
              value: '',
              required: true,
              error: false,
            },
            bank_account_number: {
              name: 'Bank account number',
              value: '',
              required: true,
              error: false,
              placeholder: 'ex. 200000000012345600',
              autocomplete: 'cc-number'
            }
          },
        },
        deliveryInfo: {
          name: 'Delivery info',
          fields: {
            delivery_city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            delivery_postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            delivery_street_address: {
              name: 'Street Address',
              value: '',
              required: true,
              error: false
            },
            delivery_contact_person: {
              name: 'Contact person',
              value: '',
              required: true,
              error: false
            },
            delivery_phone_number: {
              name: 'Phone number of the contact person',
              value: '',
              required: true,
              type: 'phone',
              error: false
            }
          },
        }
      },
      individualForms: {
        personalInfo: {
          name: 'Personal Info',
          fields: {
            job_status: {
              name: 'Job status',
              value: '',
              type: 'input',
              error: false,
              disabled: true,
            },
            unique_personal_identification_number: {
              name: 'Unique Personal Identification Number (JMBG)',
              value: '',
              required: true,
              error: false,
            },
            name: {
              name: 'Full name',
              value: '',
              required: true,
              error: false,
            },
            date_of_birth: {
              name: 'Date of Birth',
              value: '',
              type: 'date',
              required: true,
              error: false,
            },
            gender: {
              name: 'Gender',
              value: '',
              options: ['male', 'female'],
              type: 'select',
              required: true,
              error: false,
            },
            country: {
              name: 'Country',
              value: '',
              options: ['Serbia', 'Bosnia and Herzegovina', 'Slovenia', 'Croatia', 'Montenegro', 'Macedonia'],
              type: 'select',
              error: false,
            },
            city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            street_address: {
              name: 'Street address',
              value: '',
              required: true,
              error: false
            },
            phone_number: {
              name: 'Phone',
              value: '',
              type: 'phone',
              required: true,
              error: false,
            },
            main_social_network: {
              name: 'Profile picture & username from',
              value: '',
              options: [],
              type: 'select',
              error: false,
              hidden: true
            }
          }
        },
        bankingInfo: {
          name: 'Banking info',
          fields: {
            bank: {
              name: 'Bank',
              value: '',
              required: true,
              error: false,
            },
            bank_account_number: {
              name: 'Bank account number',
              value: '',
              required: true,
              error: false,
              placeholder: 'ex. 200000000012345600',
              autocomplete: 'cc-number'
            }
          },
        },
        deliveryInfo: {
          name: 'Delivery info',
          fields: {
            delivery_city: {
              name: 'City',
              value: '',
              required: true,
              error: false,
            },
            delivery_postal_code: {
              name: 'Postal code',
              value: '',
              required: true,
              error: false,
            },
            delivery_street_address: {
              name: 'Street Address',
              value: '',
              required: true,
              error: false
            },
            delivery_contact_person: {
              name: 'Contact person',
              value: '',
              required: true,
              error: false
            },
            delivery_phone_number: {
              name: 'Phone number of the contact person',
              value: '',
              required: true,
              type: 'phone',
              error: false
            }
          },
        }
      }
    };
  },

  computed: {
    user() {
      return this.$store.state.user.user;
    },
    categoriesOptions () {
      return this.$store.state.user.categories;
    },
    connectedSocialNetworks() {
      return this.$store.getters['user/connectedSocialNetworks'];
    },
    currentTab() {
      return this.$route.params.tab;
    },
    selectedFormsName() {
      return this.registeredAs + 'Forms';
    },
    selectedForms() {
      return this[this.selectedFormsName];
    },
  },
  created() {
    this.initializeFieldsFromState();
  },
  watch: {
    connectedSocialNetworks() {
      this.selectedForms.personalInfo.fields.main_social_network.options = this.connectedSocialNetworks.filter(network => network !== 'blog');
      if (this.connectedSocialNetworks.length > 0) {
        this.selectedForms.personalInfo.fields.main_social_network.hidden = false;
      } else {
        this.selectedForms.personalInfo.fields.main_social_network.hidden = true;
        this.selectedForms.personalInfo.fields.main_social_network.value = null;
      }
    }
  },
  methods: {
    async onChangedTab(newTabIndex, prevTabIndex, bvEvent) {
      if (!this.validateForms()) {
        bvEvent.preventDefault();
        return;
      }
      if(newTabIndex === 3) {
        await this.$store.dispatch('user/getCategories');
      }
    },
    initializeFieldsFromState() {
      this.$store.commit('errorBag/CLEAR');

      this.registeredAs = this.user.registered_as ? this.user.registered_as :'company';

      // eslint-disable-next-line no-unused-vars
      for (let [formKey, formValue] of Object.entries(this.selectedForms)) {
        for (let [inputKey, inputValue] of Object.entries(formValue.fields)) {
          inputValue.value = this.user[inputKey];

          if (inputKey === 'date_of_birth') {
            inputValue.value = convertToSQLDate(this.user[inputKey])
          } else if (inputKey === 'job_status') {
            if (inputValue.value === 'with_contract') {
              inputValue.value = 'With special permission (sa potvrdom)';
            } else if (inputValue.value === 'unemployed') {
              inputValue.value = 'Unemployed (nezaposlen)';
            } else if (inputValue.value === 'insured') {
              inputValue.value = 'Insured (zaposlen/penzioner)';
            } else {
              inputValue.value = 'Unemployed (nezaposlen)';
            }
          }
        }
      }

      this.categories.selected = this.user.categories

      if (this.connectedSocialNetworks.length > 0) {
        this.selectedForms.personalInfo.fields.main_social_network.hidden = false;
        this.selectedForms.personalInfo.fields.main_social_network.options = this.connectedSocialNetworks.filter(network => network !== 'blog');
      }
    },
    async complete () {
      this.$store.commit('errorBag/CLEAR');

      this.validateForms();

      if(this.categories.selected.length < 1) {
        this.categories.error = true;
      } else {
        try{
          this.$store.commit('loader/START_LOADING');
          const requestData = {
            registered_as: this.registeredAs,
            categories: this.categories.selected,
          }

          // eslint-disable-next-line no-unused-vars
          for (let [formKey, formValue] of Object.entries(this.selectedForms)) {
            for (let [inputKey, inputValue] of Object.entries(formValue.fields)) {
              requestData[inputKey] = inputValue.value;
              if (inputKey === 'job_status') {
                if (inputValue.value === 'With special permission (sa potvrdom)') {
                  requestData[inputKey] = 'with_contract';
                } else if (inputValue.value === 'Unemployed (nezaposlen)') {
                  requestData[inputKey] = 'unemployed';
                } else if (inputValue.value === 'Insured (zaposlen/penzioner)') {
                  requestData[inputKey] = 'insured';
                } else {
                  requestData[inputKey] = 'unemployed';
                }
              }
            }
          }
          const { data } = await axios.put('/profile', requestData);
          this.$store.commit('user/SET_USER', data);

          await router.push('/');
        } catch (error) {
          // eslint-disable-next-line no-empty
        } finally{
          this.$store.commit('loader/END_LOADING');
        }
      }
    },
    cancel() {
      this.initializeFieldsFromState();
    },
    validateForms() {
      let isValid = true
      for (let form in this.selectedForms) {
        isValid = isValid && this.validate(form);
      }
      if(this.categories.selected.length < 1) {
        isValid = false;
        this.categories.error = true;
      }

      return isValid;
    },
    validate(formName) {
      let isValid = true;
      let fields = this.selectedForms[formName].fields;
      for (let field in this.selectedForms[formName].fields) {

        if (fields[field].hidden) {
          continue;
        }

        // check if field is empty
        if(fields[field].value === '' || fields[field].value === null || fields[field].value === undefined) {
          fields[field].error = true;
          isValid = false;
        }

        // check special type of fields
        if(fields[field].type && validation[fields[field].type] !== undefined) {
          if(!validation[fields[field].type](fields[field].value)) {
            fields[field].error = true;
            isValid = false;
          }
        }
      }

      return isValid;
    },
    slugify: slugify,
  }
};
</script>

<template>

  <Layout>
    <div class="row">
      <div class="col-12 offset-xl-2 col-xl-8 mb-5">
        <div class="card">
          <div class="card-body">
            <ErrorAlert></ErrorAlert>
            <b-tabs nav-class="nav-tabs-custom" content-class="text-muted"  @activate-tab="onChangedTab">
              <b-tab :title="form.name" v-for="(form, key)  in this.selectedForms" :key="key" :active="currentTab === slugify(form.name)">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i :class="form.icon"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">{{ form.name }}</span>
                </template>

                <div class="p-3 mt-4">
                  <h3 class="mb-4">{{ form.name }}</h3>
                  <div class="row">
                    <div class="col-12">
                      <form :ref="form.name" autocomplete="on" @submit.prevent="complete">
                        <div v-if="key === 'personalInfo'" class="form-group row mb-3">
                          <label class="col-12 col-md-5 col-form-label">Registered as</label>
                          <div class="col-12 col-md-7">
                            <input
                                v-model="registeredAs"
                                type="text"
                                class="form-control text-capitalize not-allowed"
                                disabled
                            />
                          </div>
                        </div>
                        <div v-for="(field, fieldKey) in form.fields" :key="fieldKey"
                             :hidden="field.hidden"
                             class="form-group row mb-3">
                          <label class="col-12 col-md-5 col-form-label" :for="fieldKey">{{ field.name }}:</label>
                          <div class="col-12 col-md-7">
                            <b-form-radio-group class="mb-2" v-if="field.type === 'radio'" v-model="field.value">
                              <b-form-radio :value="true" class="mb-1">Yes</b-form-radio>
                              <b-form-radio :value="false" class="mb-1">No</b-form-radio>
                            </b-form-radio-group>
                            <div v-else-if="field.type === 'date'">
                              <date-input v-model="field.value" @input="field.error = false" :min-year="new Date().getFullYear() - 100" :max-year="new Date().getFullYear() - 13"></date-input>
                            </div>
                            <multiselect  v-else-if="field.type === 'select'"
                                          class="text-capitalize"
                                          :class="{ invalid: field.error }"
                                          v-model="field.value"
                                          :options="field.options"
                                          :allow-empty="false"
                                          deselectLabel=""
                                          @input="field.error = false"
                                          :multiple="false">
                              <template slot="option" slot-scope="props">
                                <div class="text-capitalize option__desc"><span class="option__title">{{ props.option }}</span></div>
                              </template>
                            </multiselect>
                            <phone-select
                                v-else-if="field.type === 'phone'"
                                v-model="field.value"
                                @input="field.error = false"
                                :field="field" ></phone-select>
                            <input
                                v-else
                                :id="fieldKey"
                                type="text"
                                :autocomplete="field.autocomplete"
                                class="form-control"
                                @input="field.error = false"
                                :class="{'is-invalid': field.error, 'not-allowed': field.disabled}"
                                :name="field.name.toLowerCase()"
                                :placeholder="field.placeholder"
                                v-model="field.value"
                                :disabled="field.disabled"
                            />
                          </div>
                        </div>

                        <div class="text-right mt-4">
                          <b-button type="button" variant="secondary" @click="cancel()">Cancel</b-button>
                          <b-button type="submit" variant="primary" class="ml-2" >Save</b-button>
                        </div>
                      </form>
                    </div>
                    <!-- end col -->
                  </div>
                </div>
              </b-tab>

              <b-tab title="Categories" :active="currentTab === 'categories'">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-star"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Categories</span>
                </template>

                <div class="p-3 mt-4">
                  <h3 class="mb-4">Categories</h3>

                  <div class="row">
                    <div class="col-12">
                      <div class="form-group row">
                        <label class="col-12 col-md-4 col-form-label">Choose categories:</label>
                        <div class="col-12 col-md-8">
                          <multiselect class="" :class="{ invalid: categories.error }" v-model="categories.selected" :options="categoriesOptions" @input="categories.error = false" :multiple="true"></multiselect>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="text-right mt-3">
                    <b-button type="button" variant="secondary" @click="cancel()">Cancel</b-button>
                    <b-button type="submit" variant="primary" class="ml-2" @click="complete">Save</b-button>
                  </div>
                </div>
              </b-tab>

              <b-tab title="Account" :active="currentTab === 'account'">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-user-circle"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Account</span>
                </template>

                <div class="p-3 mt-4">
                  <h3 class="mb-4">My account</h3>

                  <AccountForm @accountDataUpdate="complete" @accountDataUpdateCancel="cancel"></AccountForm>

                </div>
              </b-tab>

              <b-tab title="Networks" :active="currentTab === 'networks'">
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-share-alt"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">Networks</span>
                </template>

                <div class="p-3 mt-4">
                  <h3 class="mb-4">Networks</h3>

                  <networks-form></networks-form>

                </div>
              </b-tab>

            </b-tabs>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>

  </Layout>
</template>
